import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import axios from 'axios';

/**
 * Build jQuery plugins with jQueryBridget package. This resolved an issue
 * when trying to import Masonry class using ES6 module import statements
 */
jQueryBridget('masonry', Masonry, $);


/**
 * @param {jQuery} featuredContainer
 * @param {jQuery} nonFeaturedContainer
 * @param {string} masonryItemSelector
 */
class MNPostGrid {
    constructor(featuredContainer, nonFeaturedContainer, masonryItemSelector, postsPerPage) {

        this.featuredContainer = featuredContainer;
        this.nonFeaturedContainer = nonFeaturedContainer;
        this.masonryItemSelector = masonryItemSelector;
        if ( postsPerPage ) {
            this.postsPerPage = postsPerPage;
        } else {
            postsPerPage = 6;
        }

        this.category = null;

        this.masonryGrid = this.nonFeaturedContainer.masonry({
            itemSelector: this.masonryItemSelector,
            horizontalOrder: true,
            columnWidth: this.masonryItemSelector,
            percentPosition: true,
            transitionDuration: '0.2s',
            gutter: 46
        });

        this.location = window.location.protocol + "//" + window.location.hostname;

        this.store = {};
    }

    /**
     * Update this.store.featured with data param. Call renderFeaturedPost to keep the UI
     * in sync with the new featured post data. Call requestNonFeaturedPosts - need to call
     * this function after updating this.store.featured as it requires a field from the
     * this.store.featured (the featured ID - to exclude from the requrest).
     *
     * @param {JSON} data
     */
    updateStoreFeatured(data) {
        this.store.featured = data;

        this.renderFeaturedPost();
        this.requestNonFeaturedPosts();
    }

    /**
     * Update this.store.nonFeatured with new post data. Call renderNonFeaturedPosts to keep
     * the UI in sync with the new data.
     *
     * @param {[JSON]} data
     */
    updateStoreNonFeatured(data) {
        this.store.nonFeatured = data;
        this.renderNonFeaturedPosts();
    }

    /**
     * Build request URL using the value stored in this.category. Make request to WP API
     * to retreive featured post data. On success, call updateStoreFeatured and pass post
     * data to local data store.
     */
    requestFeaturedPost() {
        var endpoint = "/wp-json/blog-posts/featured-post";
        this.category ? endpoint += "?category=" + this.category : endpoint += "?category=";

        axios({
            method: "get",
            url: this.location + endpoint
        })
        .then( (response) => {
            if ( response.data ) {
                this.updateStoreFeatured(response.data);
            } else {
                this.resetStore();
                this.renderNoPostsFound();
            }
        })
        .catch( (error) => {
            console.log( error );
        });
    }

    /**
     * Replace existing featured post markup with data stored in this.store.featured.
     */
    renderFeaturedPost() {
        if ( this.store && this.store.featured ) {
            var container = this.featuredContainer, links = container.find('a'),
                imageContainer = container.find('.featured-post-image'), image = imageContainer.find('img'),
                textContainer = container.find('.featured-post-text'), h1 = textContainer.find('h1'),
                inlineFilterLinks = textContainer.find('a.inline-blog-filter'), catLink = textContainer.find('.category-link'),
                button = textContainer.find('a.btn'), buttonLabel = "read our " + this.store.featured.post_identifier + " post";

            imageContainer.removeClass('error');

            image.prop('src', this.store.featured.image_src);
            image.prop('srcset', this.store.featured.image_srcset);
            image.prop('alt', this.store.featured.title);

            links.prop('href', this.store.featured.permalink);
            catLink.show();

            inlineFilterLinks.text(this.store.featured.categories[0].name);
            inlineFilterLinks.data('blog-filter-category', this.store.featured.categories[0].slug);

            h1.text(this.store.featured.title);

            button.removeClass('inline-blog-filter');
            button.text(buttonLabel);

        } else {
            return;
        }
    }

    /**
     * Update posts UI
     */
    renderNoPostsFound() {
        var container = this.featuredContainer, nonFeaturedContainer = this.nonFeaturedContainer,
            imageContainer = container.find('.featured-post-image'), image = imageContainer.find('img'),
            textContainer = container.find('.featured-post-text'), catLink = textContainer.find('.category-link'),
            h3 = textContainer.find('h3'), h1 = textContainer.find('h1');

        var button = textContainer.find('a.btn');

        imageContainer.addClass('error');

        image.prop('src', '');
        image.prop('srcset', '');

        h3.text("Error");
        h1.text("No posts found matching this category");

        catLink.hide();
        button.addClass("inline-blog-filter");
        button.prop('href', this.location);
        button.text("Back to all posts");

        nonFeaturedContainer.html('').css('height', '0px');
    }

    /**
     * Reset store data
     */
    resetStore() {
        this.store = {}
    }

    /**
     * Build request URL using values stored in this.category. Exclude featured post
     * ID from returned posts by passing this.store.featured.ID to the exclude URL param.
     * On success, call updateStoreNonFeatured and pass post data array.
     */
    requestNonFeaturedPosts() {
        var endpoint = "/wp-json/blog-posts/non-featured-posts";

        if ( this.category ) {
            endpoint += "?category=" + this.category;
        }

        if ( this.store && this.store.featured ) {
            if ( this.category ) {
                endpoint += "&exclude=" + this.store.featured.ID;
            } else {
                endpoint += "?exclude=" + this.store.featured.ID
            }
        }

        axios({
            method: "get",
            url: this.location + endpoint
        })
        .then( (response) => {
            if ( response.data ) {
                this.updateStoreNonFeatured(response.data);
            }
        })
        .catch( (error) => {
            console.log( error );
        });
    }

    /**
     * Programmatically build markup for individual non-featured post. Returns structured
     * markup for a single post.
     *
     * @param {JSON} post
     */
    buildNonFeaturedPostMarkup(post) {
        if(post) {
            var button_label = "read this post",
                markup = "";
                markup += "<div class='blog-post post-wrap'>";
                markup += "<a href='" + post.permalink + "' class='image'>";
                markup += "<div class='thumbnail'><div class='overlay'>";
                  markup += "<span class='btn'>"+ button_label +"</span></div>";
                      markup += "<img src='" + post.image_src + "' alt='"+ post.title +"' srcset='" + post.image_srcset + "' sizes='(min-width: 767px) 50vw, (min-width: 1024px) 33vw, (min-width: 1500px) 25vw, 100vw'>";
                  markup += "</div>";
                markup += "</a>";
                markup += "<a href='/category/"+post.categories[0].slug+"' class='inline-blog-filter' data-blog-filter-category='"+post.categories[0].slug+"'>" + post.categories[0].name +"</a>";
                markup += "<h3><a href='"+ post.permalink +"' class='title'>" + post.title + "</h3>";
                markup += "<div class='button-wrap mobile'><a href='"+ post.permalink +"' class='btn'>"+ button_label +"</a></div>";
            markup += "</div>";

            return markup;
        } else {
            return;
        }
    }

    /**
     * Remove HTML from inside the non-featured post container. Loop through posts stored in
     * this.store.nonFeatured and pass each post to buildNonFeaturedPostMarkup to build markup.
     * Append each post to non-featured post container and masonry grid object. Add imagesLoaded
     * event listener to container - update grid layout after each image has loaded.
     */
    renderNonFeaturedPosts() {
        if (this.store && this.store.nonFeatured) {
            var container = this.nonFeaturedContainer;
            var that = this; // handle changing context of 'this' keyword

            container.html("");

            if ( this.store.nonFeatured.length > 0 ) {
                this.store.nonFeatured.map( (post, index) => {
                    if ( index < this.postsPerPage ) {
                        var $post = $(this.buildNonFeaturedPostMarkup(post));
                        that.masonryGrid.append($post).masonry('appended', $post);

                        if (index<=2) {
                          var $divider = $('<span class="divider"></span>');
                          that.masonryGrid.append($divider).masonry('appended', $divider);
                        }
                    }
                });

                this.nonFeaturedContainer.imagesLoaded().progress( function() {
                    that.masonryGrid.masonry('layout');
                }).done(function() {
                    $(window).trigger('resize');
                });

            } else {
                container.css('height', '0px');
            }

        } else {
            return;
        }
    }

    /**
     * Sets this.category var to the value passed in the category param. Call requestFeaturedPost.
     *
     * @param {string} category
     */
    renderUI(category) {
        this.category = category;
        this.requestFeaturedPost();
    }

    /**
     * Check if this.store.nonFeatured has additional (not already loaded) posts to load. If so,
     * loop through posts and call buildNonFeaturedPostMarkup to build markup for each. Append each
     * post to the non-featured container and masonry grid object. Append an imagesLoaded event listener
     * to the non-featured container and update masonry layout after each image laods.
     */
    appendToGrid() {
        if ( this.store && this.store.nonFeatured ) {
            var loadedPosts = this.nonFeaturedContainer.children();
            var nonFeaturedPosts = this.store.nonFeatured;
            var that = this; // handle changing context of 'this' keyword

            if ( loadedPosts.length < nonFeaturedPosts.length ) {
                nonFeaturedPosts.map( (post, index) => {
                    if ( index >= loadedPosts.length && index <= loadedPosts.length + 9 ) { // loads nine more posts
                        var $post = $(this.buildNonFeaturedPostMarkup(post));
                        that.masonryGrid.append($post).masonry('appended', $post);
                    }
                });

                that.nonFeaturedContainer.imagesLoaded().progress( function() {
                    that.masonryGrid.masonry('layout');
                }).done(function() {
                  $(window).trigger('resize');
                });
            }
        }
    }
}


jQuery(document).ready(function($) {

    const $filterUI = $('#filter-ui');
    const $featuredContainer = $('#featured-container');
    const $nonFeaturedContainer = $('#non-featured-container');
    const masonryItemSelector = ".blog-post";
    const postsPerPage = $nonFeaturedContainer.data('posts-per-page');

    const mnPostGrid = new MNPostGrid($featuredContainer, $nonFeaturedContainer, masonryItemSelector, postsPerPage);

    const $window = $(window);

    // Check for hash and load. Update filterUI dropdown
    // selection and update post grid accordingly
    if ( window.location.hash ) {
        var category = window.location.hash.substr(1);
        $filterUI.val(category);
        var selectedText = $('#filter-ui').find('option[value="'+category+'"]').text();
        if (!selectedText.length) {
          selectedText = $('#filter-ui').find('option[value=""]').text();
        }
        $('#select2-filter-ui-container').text(selectedText);
        mnPostGrid.renderUI(category);

    } else {
        mnPostGrid.renderUI();
    }

    // Update grid to respond to changes to the URL hash
    $window.on('hashchange', function( e ) {
        var category = window.location.hash.substr(1);
        $filterUI.val(category);
        var selectedText = $('#filter-ui').find('option[value="'+category+'"]').text();
        if (!selectedText.length) {
          selectedText = $('#filter-ui').find('option[value=""]').text();
        }
        $('#select2-filter-ui-container').text(selectedText);
        mnPostGrid.renderUI(category);
    } );

    // Update URL hash on filter UI change
    $filterUI.on('change', function() {
        var category = $(this).val();
        window.location.hash = category;
    });

    // Support infinite scroll functionality
    $window.on('scroll', function() {
        var windowScrollPos = $window.scrollTop();
        var containerOffset = $nonFeaturedContainer.offset().top;
        var containerHeight = $nonFeaturedContainer.outerHeight();
        var containerOffsetBottom = containerOffset + containerHeight;
        var loadPostsAtScrollPos = containerOffsetBottom - $window.height();

        if ( windowScrollPos >= loadPostsAtScrollPos ) {
            mnPostGrid.appendToGrid();
        }
    });

    // Support inline links used to filter post grid
    $('.blog').on('click', '.inline-blog-filter', function(event) {
        event.preventDefault();
        var category = $(this).data('blog-filter-category');
        var hash = window.location.hash.substr(1);

        if ( category != hash ) {

            if ( category === undefined ) {
                window.location.hash = "";
            } else {
                window.location.hash = category;
            }

            // Bring user to the top of the window
            $("html, body").stop().animate({scrollTop: 0}, 1000, 'swing');
        }
    });
});
